import { Stack, Text } from '@chakra-ui/react'

import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import CustomFormFileAnswer from 'components/tools/CustomForm/commonComponents/CustomFormSingleFileAnswer'
import CustomFormEmptyAnswerFeedback from 'components/tools/CustomForm/commonComponents/CustomFormEmptyAnswerFeedback'

export default function CustomFormMultipleFilesAnswer() {
  const { answer } = useCustomFormAnswer()

  const answerFiles = (answer.answer as any) || []

  if (answerFiles?.length == 0) {
    return (
      <Text variant="secondary" fontStyle="italic">
        Sem resposta
      </Text>
    )
  }

  return (
    <CustomFormEmptyAnswerFeedback>
      <Stack>
        {answerFiles.map(([fileId, fileSlug, archiveId]: [string, string, string]) => {
          return <CustomFormFileAnswer key={fileId} fileId={fileId} fileSlug={fileSlug} archiveId={archiveId} />
        })}
      </Stack>
    </CustomFormEmptyAnswerFeedback>
  )
}
